import type { ConsoleClient } from "@colossus/api-client";
import type { GuildBadge } from "@colossus/contracts";

export interface ShowcaseServer {
  readonly name: string;
  readonly icon: string | null;
  readonly badge: GuildBadge | null;
}

export const middleOf = (count: number): number => Math.floor(count / 2);

const fromTheMiddle = <T>(biggestFirst: readonly T[]): T[] => {
  const left: T[] = [];
  const right: T[] = [];
  biggestFirst.forEach((item, index) => (index % 2 === 0 ? right : left).push(item));
  return [...left.reverse(), ...right];
};

export const loadShowcase = async (client: ConsoleClient): Promise<readonly ShowcaseServer[]> => {
  try {
    const result = await client.call("get", "/api/showcase");
    return result.ok ? fromTheMiddle(result.data.servers) : [];
  } catch {
    return [];
  }
};
